import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';
import { Icon } from '@kueski-dev/kueski-design-system';

const RightArrow = ({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (

  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    <Icon
      name="ArrowRightLine"
      width={size}
      height={size}
      fillColor={color}
    />
  </WithIconRounded>
);

RightArrow.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

RightArrow.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#18223D',
  containerColor: null,
  containerSize: 12,
  onClick: null,
  round: false,
  size: 12,
};

export default RightArrow;
